import React, {memo, useEffect, useState} from 'react';
import {onClickHandler} from '../../../../../utils/onclick';

import './index.scss';
import {RawDevice} from '../../../../../store/setup/state';
import {useSelector} from 'react-redux';
import {useOrientation} from '../../../../../hooks/orientation';
import {useRPC} from '../../../../../hooks/rpc';
import {useMessage} from '../../../../../hooks/message';
import {useLocalization} from "../../../../../hooks/localization";

type Props = {
    onClosePressed: () => void;
    rawDevice: RawDevice;
    deviceName: string;
    deviceImage: string;
};

function createNullArray(count) {
    if (!count) {
        return [];
    }

    return Array(count).fill(null);
}

export const SetupIOTestComponent = memo(function SetupIOTestComponent(props: Props) {
    const {
        onClosePressed,
        rawDevice,
        deviceName,
        deviceImage,
    } = props;
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const {failure} = useMessage();
    const orientation = useOrientation();
    const deviceType = useSelector(state => state.control.bridgeDeviceTypeList.find(d => d.id === rawDevice.device_type_id));

    const [outputs, setOutputs] = useState<boolean[]>(createNullArray(deviceType?.output_count));
    const [inputs, setInputs] = useState<boolean[]>(createNullArray(deviceType?.input_count));

    const outputClick = (slot: number) => {
        const newOutputs = outputs.map((o, i) => {
            if (i === slot) {
                return !o;
            }

            return o == null ? null : false;
        });
        rpc.setDirectOutput(rawDevice.gateway_id, rawDevice.unique_device_id, slot, newOutputs[slot] ? 1 : 0)
            .then(() => setOutputs(newOutputs))
            .catch(failure);
    };

    const inputClick = (slot: number) => {
        rpc.getDirectInput(rawDevice.gateway_id, rawDevice.unique_device_id, slot)
            .then((value) => setInputs(inputs => inputs.map((v, i) => {
                if (i === slot) {
                    return Boolean(value);
                }

                return v;
            })))
            .catch(failure);
    };

    useEffect(() => {
        setOutputs(createNullArray(deviceType?.output_count));
    }, [deviceType?.output_count]);

    useEffect(() => {
        setInputs(createNullArray(deviceType?.input_count));
    }, [deviceType?.input_count]);

    return (
        <div className={`io-test-modal ${orientation}`}>
            <div className='top'>
                <div className='left'>
                    <span className='title'>{t('io_test')}</span>
                    <img className='image' src={deviceImage} alt=''/>
                    <span className='name'>{deviceType?.name || '-'}</span>
                </div>
                <div className='middle'>
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('device_name')}:</span> {deviceName}
                        </span>
                    </div>
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('unique_id')}:</span> {rawDevice.unique_device_id}
                        </span>
                    </div>
                    {/*<div className='label-text-container'>*/}
                    {/*    <span className='label'><span className='label-title'>{t('VERSION')}:</span> 1.27</span>*/}
                    {/*</div>*/}
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('rf_power')}:</span> {rawDevice.rf_power.toString()}
                        </span>
                    </div>
                </div>
                <div className='right'>
                    <span className='close-text' {...onClickHandler(onClosePressed)}>{t('close')}</span>
                </div>
            </div>
            <div className='bottom'>
                <div className='inputs'>
                    {
                        inputs.map((state, i) => (
                            <div key={`input_${i}`} onClick={() => inputClick(i)}>
                                <span>{`IN${i}`}</span>
                                <div className={'input-button' + (state == null ? '' : (state ? ' green' : ' red'))}/>
                            </div>
                        ))
                    }
                </div>
                <div className='outputs'>
                    {
                        outputs.map((state, i) => (
                            <div key={`output_${i}`} onClick={() => outputClick(i)}>
                                <span>{`Q${i}`}</span>
                                <div className={'output-button' + (state == null ? '' : (state ? ' green' : ' red'))}/>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
});
